import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDivision = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 960 960'
    width='1em'
    height='1em'
    {...props}
  >
    <path d='M648 248c-56-28.7-117.3-43-184-43s-128 14.3-184 43L32 0h320l112 112L576 0h320zM464 960c-93.3 0-172.7-32.7-238-98s-98-144.7-98-238 32.7-172.7 98-238 144.7-98 238-98 172.7 32.7 238 98 98 144.7 98 238-32.7 172.7-98 238-144.7 98-238 98m-48-160h128V448h-96c-20 59.3-62.7 91.3-128 96v64h96z' />
  </svg>
);
export default SvgDivision;
